module.exports = __webpack_public_path__ + "img/delete-file.a82aabad.svg";